const collection = {
	init: () => {
		collection.switchView();
		collection.switchLayout();
	},
	switchView: () => {
		document.querySelectorAll(".js-view-switcher").forEach((switcher) => {
			switcher.addEventListener("click", (ev) => {
				ev.preventDefault();

				const views = document.querySelectorAll(".js-view");

				views.forEach((view) => {
					if (view.classList.contains("is-active")) {
						// Fade out current view
						fadeOut(view, () => {
							views.forEach((nextView) => {
								if (!nextView.classList.contains("is-active")) {
									// Fade in next view
									fadeIn(nextView, () => {
										nextView.classList.add("is-active");
									});
								}
							});

							view.classList.remove("is-active");
						});
					}
				});
			});
		});
	},
	switchLayout: () => {
		document
			.querySelectorAll(".js-layout-switcher")
			.forEach((switcher) => {
				switcher.addEventListener("click", (ev) => {
					ev.preventDefault();

					document
						.querySelectorAll(".js-layout-switcher")
						.forEach((el) => {
							el.classList.remove("is-active");
						});
					switcher.classList.add("is-active");

					const views = document.querySelectorAll(".js-layout");

					views.forEach((view) => {
						if (view.classList.contains("is-active")) {
							fadeOut(view, () => {
								views.forEach((nextView) => {
									if (!nextView.classList.contains("is-active")) {
										fadeIn(
											nextView,
											() => {
												nextView.classList.add("is-active");
											},
											"grid"
										);
									}
								});

								view.classList.remove("is-active");
							});
						}
					});
				});
			});
	},
};

const overlay = {
	trigger: () => {
		document.querySelectorAll(".js-overlay-trigger").forEach((trigger) => {
			trigger.addEventListener("click", (e) => {
				e.preventDefault();
				document.body.classList.toggle("is-overlay-active");
			});
		});
	},
};

const intro = function () {
	var header = document.querySelector(".b-header");
	if (!header || !document.body.classList.contains("index")) return;

	function updateHeaderHeight() {
		var h = header.getBoundingClientRect().height || 110;
		document.documentElement.style.setProperty(
			"--header-height",
			h + "px"
		);
		return h;
	}

	function onScroll() {
		var h = updateHeaderHeight();
		var viewportCenter = window.innerHeight / 2 - h / 2; // posició inicial al mig
		var scrollY = window.scrollY;

		// nova posició = posició inicial - scroll
		var newTop = viewportCenter - scrollY;

		if (newTop <= 0) {
			// ha arribat a dalt → fixa
			header.style.top = "0px";
			header.classList.add("is-docked");
		} else {
			// encara està pujant
			header.style.top = newTop + "px";
			header.classList.remove("is-docked");
		}
	}

	window.addEventListener("load", onScroll);
	window.addEventListener("resize", onScroll);
	window.addEventListener("scroll", onScroll, { passive: true });
};

const cart = {
	trigger: () => {
		const cart = document.querySelector(".b-cart");
		document.querySelectorAll(".js-cart-trigger").forEach((trigger) => {
			trigger.addEventListener("click", (e) => {
				console.log("hey");
				e.preventDefault();
				cart.classList.toggle("is-visible");
			});
		});
	},
	update: function () {
		const buttonsPlus = document.querySelectorAll(".button-plus");
		const buttonsMinus = document.querySelectorAll(".button-minus");
		const inputs = document.querySelectorAll('input[type="number"]');

		buttonsPlus.forEach((button) => {
			button.addEventListener("click", function (e) {
				if (this.classList.contains("side")) {
					e.preventDefault();
				}
				const input = this.parentElement.querySelector("input");
				const mirror = this.parentElement.querySelector(".value-mirror");
				input.value = parseInt(input.value) + 1;
				mirror.textContent = input.value;
			});
		});

		buttonsMinus.forEach((button) => {
			button.addEventListener("click", function (e) {
				if (this.classList.contains("side")) {
					e.preventDefault();
				}
				const input = this.parentElement.querySelector("input");
				const mirror = this.parentElement.querySelector(".value-mirror");
				if (parseInt(input.value) > 0) {
					input.value = parseInt(input.value) - 1;
					mirror.textContent = input.value;
				}
			});
		});

		inputs.forEach((input) => {
			input.addEventListener("change", function () {
				if (parseInt(this.value) < 0) {
					this.value = 0;
				}
			});
		});
	},
};

function fadeOut(element, callback) {
	element.style.opacity = 1;
	element.style.transition = "opacity 0.5s ease-out";
	element.style.opacity = 0;

	setTimeout(() => {
		element.style.display = "none";
		if (callback) callback();
	}, 500);
}

function fadeIn(element, callback, mode = "block") {
	element.style.display = mode;
	element.style.opacity = 0;
	element.style.transition = "opacity 0.5s ease-in";

	setTimeout(() => {
		element.style.opacity = 1;
		if (callback) callback();
	}, 10);
}

document.addEventListener("DOMContentLoaded", function () {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);

	collection.init();
	overlay.trigger();
	cart.trigger();
	cart.update();

	intro();
});
